import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Createcareer = () => {
  const [formData, setFormData] = useState({
    role: "",
    vacancy: "",
    job_description: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("access");

      // Create FormData instead of JSON
      const formDataToSend = new FormData();
      formDataToSend.append("role", formData.role);
      formDataToSend.append("vacancy", formData.vacancy);
      formDataToSend.append("job_description", formData.job_description);

      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/careers/add/",
        {
          method: "POST",
          headers: {
            // Remove Content-Type header - let browser set it automatically
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend, // Use FormData instead of JSON
        }
      );

      if (response.ok) {
        setMessage("Career posting created successfully!");
        setTimeout(() => {
          navigate("/careers");
        }, 1500);
      } else {
        const errorData = await response.json();
        setMessage(errorData.detail || "Failed to create career posting.");
      }
    } catch (error) {
      console.error("Error creating career:", error);
      setMessage("An error occurred while creating the career posting.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Create New Career Posting</h4>
            </div>
            <div className="card-body">
              {message && (
                <div
                  className={`alert ${
                    message.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  } alert-dismissible fade show`}
                >
                  {message}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setMessage("")}
                  ></button>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">
                    Role *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="vacancy" className="form-label">
                    Number of Vacancies *
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="vacancy"
                    name="vacancy"
                    min="1"
                    value={formData.vacancy}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="job_description" className="form-label">
                    Job Description *
                  </label>
                  <textarea
                    className="form-control"
                    id="job_description"
                    name="job_description"
                    rows="8"
                    value={formData.job_description}
                    onChange={handleChange}
                    required
                    placeholder="Describe the job responsibilities, requirements, benefits, etc."
                  ></textarea>
                </div>

                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate("/careers")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Career Posting"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Createcareer;
